import { Lock } from '../../ui/icons';
import { countdownDetailed } from '../../../lib/format';

/** Red lock pill — time left before the stage rolls out and picks freeze. */
export function LockCountdownBadge({ lockAt, now }: { lockAt: number; now: number }) {
  return (
    <div className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[rgba(228,50,43,0.28)] bg-[rgba(228,50,43,0.1)] px-[11px] py-1.5">
      <Lock width={11} height={11} strokeWidth={2.4} className="text-[#E4322B]" />
      <span className="num text-[12.5px] font-extrabold tracking-[-0.01em] text-[#E4322B]">
        {countdownDetailed(lockAt, now)}
      </span>
    </div>
  );
}
